// src/components/Products/ProductTable.jsx
import React from 'react';
import RoleBasedComponent from '../common/RoleBasedComponent';

const ProductTable = ({ products, onEdit, onDelete, isLoading }) => {
  const handleEdit = (product) => {
    if (onEdit) onEdit(product);
  };

  const handleDelete = (product) => {
    if (onDelete) onDelete(product);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return 'N/A';
    }
  };

  const getCategoryName = (category) => {
    return category?.name || 'Unknown';
  };

  if (isLoading) {
    return (
      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Product Name</th>
              <th>Category</th>
              <th>Description</th>
              <th>SKU</th>
              <th>Total Stock</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" className="inventory-loading">
  <div className="spinner-wrapper">
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px'
    }}>
      <div className="inventory-spinner"></div>
      <span>Loading product data...</span>
    </div>
  </div>
</td>
            </tr>
          </tbody>
        </table>
        <style>{`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .inventory-loading {
    text-align: center;
    vertical-align: middle;
  }

  .inventory-loading .spinner-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 120px;
  }

  .inventory-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #E5E7EB;
    border-top: 4px solid #004080;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
`}</style>

      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Product Name</th>
              <th>Category</th>
              <th>Description</th>
              <th>SKU</th>
              <th>Total Stock</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                No products found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Product Name</th>
            <th>Category</th>
            <th>Description</th>
            <th>SKU</th>
            <th>Total Stock</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>{product.id}</td>
              <td>{product.name || 'N/A'}</td>
              <td>{getCategoryName(product.category)}</td>
              <td>{product.description || '-'}</td>
              <td>{product.sku || '-'}</td>
              <td>{product.totalStock || '-'}</td>
              <td>{formatDate(product.createdAt)}</td>
              <td>
                <button 
                  className="btn btn-action btn-edit" 
                  onClick={() => handleEdit(product)}
                >
                  Edit
                </button>
                <RoleBasedComponent allowedRoles={['superadmin']}>
                  <button
                    className="inventory-btn inventory-btn-action inventory-btn-delete"
                    onClick={() => handleDelete(product)}
                    title="Delete this product"
                    style={{ marginLeft: '8px' }}
                  >
                    Delete
                  </button>
                </RoleBasedComponent>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;